import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromRaffle from '../raffle/raffle.reducer'
import { RaffleFormComponent } from './form/form.component'
import { RaffleGeneralTabComponent } from './general-tab/show.component'
import { RaffleIndexComponent } from './index/index.component'
import { RaffleRoutingModule } from './raffle-routing.module'
import { RaffleEffects } from './raffle.effects'
import { RaffleSerializer } from './raffle.serializer'
import { RaffleService } from './raffle.service'
import { RaffleShowComponent } from './show/show.component'
import { RaffleTableComponent } from './table/table.component'
import { RaffleCreateComponent } from './create/show.component'
import { RaffleCreateModalComponent } from './create-modal/show.component'
import { ProductModule } from '../product/product.module'
import { BookingModule } from '../booking/booking.module'
import { RaffleLotModule } from './raffle-lot/raffle-lot.module'
import { RaffleLinkedSubscriptionsTabComponent } from './linked-subscriptions-tab/show.component'
import { SubscriptionModule } from '../subscription/subscription.module'
import { RaffleResultsTabComponent } from './results-tab/show.component'
import { ShowModalModule } from './show-modal/ShowModal.module'

@NgModule({
  imports: [
    RaffleRoutingModule,
    SharedModule,
    StoreModule.forFeature(fromRaffle.FEATURE_NAME, fromRaffle.raffleReducer),
    EffectsModule.forFeature([RaffleEffects]),
    ProductModule,
    BookingModule,
    RaffleLotModule,
    SubscriptionModule,
    ShowModalModule
  ],
  declarations: [
    RaffleIndexComponent,
    RaffleFormComponent,
    RaffleTableComponent,
    RaffleShowComponent,
    RaffleResultsTabComponent,
    RaffleGeneralTabComponent,
    RaffleCreateComponent,
    RaffleCreateModalComponent,
    RaffleLinkedSubscriptionsTabComponent
  ],
  exports: [],
  providers: [
    RaffleService,
    {
      provide: RaffleSerializer,
      useClass: RaffleSerializer
    }
  ]
})
export class RaffleModule {}
